(function () {
  var STORAGE_KEY = "wearable:favourites";
  var ITEM_CAP = 24;
  var shareState = { shareEnabled: false, shareUrl: "" };
  var persistTimer = null;
  var synced = false;

  function configRoot() {
    return document.querySelector("[data-favourites-drawer]");
  }

  function isLoggedIn() {
    var root = configRoot();
    return Boolean(root && root.getAttribute("data-logged-in") === "true");
  }

  function isRecipientView() {
    return Boolean(shareSlugFromLocation());
  }

  function proxyBase() {
    var root = configRoot() || document.querySelector("[data-wishlist-page]");
    return (root && root.getAttribute("data-proxy-base")) || "/apps/tryon";
  }

  function displayNameFromDom() {
    var root = configRoot() || document.querySelector("[data-wishlist-page]");
    return ((root && root.getAttribute("data-display-name")) || "").trim();
  }

  function shareSlugFromLocation() {
    try {
      var params = new URLSearchParams(window.location.search);
      var fromQuery = (params.get("w") || "").trim().toLowerCase();
      if (/^[a-f0-9]{24}$/.test(fromQuery)) return fromQuery;
      var parts = window.location.pathname.split("/").filter(Boolean);
      if (parts.length >= 3 && parts[0] === "pages" && parts[1] === "wishlist") {
        var fromPath = (parts[2] || "").toLowerCase();
        if (/^[a-f0-9]{24}$/.test(fromPath)) return fromPath;
      }
    } catch (e) {}
    return "";
  }

  function upgradeImageUrl(url) {
    if (!url) return "";
    return String(url)
      .replace(/([?&]width=)\d+\b/g, "$1900")
      .replace(/_(\d+)x(?:\d+)?(?=\.)/g, "_900x");
  }

  function read() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]").map(function (item) {
        if (!item || typeof item !== "object") return item;
        return Object.assign({}, item, { image: upgradeImageUrl(item.image || "") });
      });
    } catch (e) {
      return [];
    }
  }

  function write(items) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (e) {}
    document.dispatchEvent(new CustomEvent("favourites:updated"));
  }

  function productFromEl(el) {
    if (!el) return null;
    return {
      id: String(el.getAttribute("data-product-id") || ""),
      handle: el.getAttribute("data-product-handle") || "",
      title: el.getAttribute("data-product-title") || "",
      url: el.getAttribute("data-product-url") || "",
      image: upgradeImageUrl(el.getAttribute("data-product-image") || ""),
      price: el.getAttribute("data-product-price") || "",
      variantId: el.getAttribute("data-product-variant-id") || "",
    };
  }

  function isFavourite(id) {
    return read().some(function (item) {
      return String(item.id) === String(id);
    });
  }

  function toggle(product) {
    if (!product || !product.id) return false;
    var items = read();
    var idx = items.findIndex(function (item) {
      return String(item.id) === String(product.id);
    });
    if (idx >= 0) {
      items.splice(idx, 1);
      write(items);
      schedulePersist();
      return false;
    }
    items.unshift(product);
    write(items.slice(0, ITEM_CAP));
    schedulePersist();
    return true;
  }

  function removeById(id) {
    write(
      read().filter(function (fav) {
        return String(fav.id) !== String(id);
      }),
    );
    schedulePersist();
  }

  function mergeItems(local, server) {
    var merged = [];
    var seen = {};
    var list = (local || []).concat(server || []);
    for (var i = 0; i < list.length; i++) {
      var item = list[i];
      var id = String((item && (item.id || item.productId)) || "");
      if (!id || seen[id]) continue;
      seen[id] = true;
      merged.push({
        id: id,
        handle: item.handle || "",
        title: item.title || "",
        url: item.url || "",
        image: upgradeImageUrl(item.image || ""),
        price: item.price || "",
        variantId: item.variantId || "",
      });
      if (merged.length >= ITEM_CAP) break;
    }
    return merged;
  }

  function toServerItems(items) {
    return (items || []).map(function (item) {
      return {
        productId: String(item.id || item.productId || ""),
        handle: item.handle || "",
        title: item.title || "",
        url: item.url || "",
        image: upgradeImageUrl(item.image || ""),
        price: item.price || "",
        variantId: item.variantId || "",
      };
    });
  }

  function fromServerItems(items) {
    return (items || []).map(function (item) {
      return {
        id: String(item.productId || item.id || ""),
        handle: item.handle || "",
        title: item.title || "",
        url: item.url || "",
        image: upgradeImageUrl(item.image || ""),
        price: item.price || "",
        variantId: item.variantId || "",
      };
    });
  }

  function updateCounts() {
    var count = read().length;
    document.querySelectorAll("[data-favourites-count]").forEach(function (el) {
      el.textContent = String(count);
    });
  }

  function updateToggleButtons() {
    document.querySelectorAll("[data-favourite-toggle]").forEach(function (btn) {
      var id = btn.getAttribute("data-product-id");
      var active = isFavourite(id);
      btn.classList.toggle("is-active", active);
      btn.setAttribute("aria-pressed", active ? "true" : "false");
      var label = btn.getAttribute(active ? "data-label-remove" : "data-label-add");
      if (label) btn.setAttribute("aria-label", label);
    });
  }

  function renderDrawer() {
    var body = document.querySelector("[data-favourites-drawer-body]");
    if (!body) return;

    var items = read();
    body.replaceChildren();

    if (!items.length) {
      var empty = document.createElement("p");
      empty.className = "favourites-drawer__empty";
      empty.textContent =
        body.getAttribute("data-empty-text") || "Your wish list is empty.";
      body.appendChild(empty);
      updateFooter();
      return;
    }

    items.forEach(function (item) {
      var line = document.createElement("div");
      line.className =
        "cart-drawer__line" + (item.image ? "" : " cart-drawer__line--no-media");
      line.setAttribute("data-favourite-line", String(item.id || ""));

      if (item.image) {
        var img = document.createElement("img");
        img.src = item.image;
        img.alt = "";
        img.width = 72;
        img.height = 72;
        line.appendChild(img);
      }

      var meta = document.createElement("div");
      var link = document.createElement("a");
      link.href = item.url || "/products/" + (item.handle || "");
      link.textContent = item.title || item.handle || "";
      meta.appendChild(link);

      if (item.price) {
        var price = document.createElement("p");
        price.style.margin = "0.35rem 0 0";
        price.style.fontSize = "0.8125rem";
        price.textContent = item.price;
        meta.appendChild(price);
      }

      line.appendChild(meta);

      var remove = document.createElement("button");
      remove.type = "button";
      remove.className = "favourites-drawer__remove";
      remove.setAttribute("data-favourite-remove", String(item.id || ""));
      remove.setAttribute("aria-label", "Remove");
      remove.textContent = "\u00d7";
      remove.addEventListener("click", function () {
        removeById(remove.getAttribute("data-favourite-remove"));
        updateCounts();
        updateToggleButtons();
        renderDrawer();
      });
      line.appendChild(remove);

      body.appendChild(line);
    });
    updateFooter();
  }

  function updateFooter() {
    var footer = document.querySelector("[data-wishlist-footer]");
    if (!footer) return;
    var items = read();
    var recipient = isRecipientView();
    var show = items.length > 0 && !recipient;
    footer.hidden = !show;
    var guest = footer.querySelector("[data-wishlist-guest]");
    var owner = footer.querySelector("[data-wishlist-owner]");
    if (guest) guest.hidden = !show || isLoggedIn();
    if (owner) owner.hidden = !show || !isLoggedIn();
    syncShareUi(document);
  }

  function syncShareUi(root) {
    if (!root) return;
    var enabled = Boolean(shareState.shareEnabled && shareState.shareUrl);
    root.querySelectorAll("[data-wishlist-hint-intro]").forEach(function (el) {
      el.hidden = enabled;
    });
    root.querySelectorAll("[data-wishlist-live-note]").forEach(function (el) {
      el.hidden = !enabled;
    });
    root.querySelectorAll("[data-wishlist-stop]").forEach(function (el) {
      el.hidden = !enabled;
    });
    root.querySelectorAll("[data-wishlist-copy]").forEach(function (el) {
      el.hidden = !enabled;
      el.classList.toggle("button--outline", false);
    });
    root.querySelectorAll("[data-wishlist-drop-hint]").forEach(function (el) {
      el.hidden = enabled;
      el.classList.toggle("button--outline", false);
    });
    root.querySelectorAll("[data-wishlist-share-panel]").forEach(function (el) {
      el.hidden = !enabled;
    });
  }

  function openDrawer() {
    var drawer = document.querySelector("[data-favourites-drawer]");
    if (!drawer) return;
    renderDrawer();
    drawer.classList.add("is-open");
    drawer.setAttribute("aria-hidden", "false");
  }

  function closeDrawer() {
    var drawer = document.querySelector("[data-favourites-drawer]");
    if (!drawer) return;
    drawer.classList.remove("is-open");
    drawer.setAttribute("aria-hidden", "true");
  }

  function toggleProduct(el) {
    var product = productFromEl(el);
    if (!product) return;
    var added = toggle(product);
    updateCounts();
    updateToggleButtons();
    if (added && document.querySelector("[data-favourites-drawer]")) {
      openDrawer();
    } else {
      renderDrawer();
    }
  }

  function schedulePersist() {
    if (!isLoggedIn() || isRecipientView()) return;
    clearTimeout(persistTimer);
    persistTimer = setTimeout(persistToServer, 250);
  }

  function persistToServer() {
    if (!isLoggedIn()) return Promise.resolve();
    return fetch(proxyBase() + "/wishlist.json", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      cache: "no-store",
      body: JSON.stringify({
        action: "save",
        items: toServerItems(read()),
        displayName: displayNameFromDom(),
      }),
    }).then(function (res) {
      if (!res.ok) return null;
      return res.json();
    }).then(function (data) {
      if (!data) return;
      if (data.shareEnabled != null) shareState.shareEnabled = Boolean(data.shareEnabled);
      if (data.shareUrl) shareState.shareUrl = data.shareUrl;
      updateFooter();
    }).catch(function () {});
  }

  function pullAndMerge() {
    if (!isLoggedIn() || isRecipientView()) return Promise.resolve();
    return fetch(proxyBase() + "/wishlist.json", { cache: "no-store" })
      .then(function (res) {
        if (!res.ok) return null;
        return res.json();
      })
      .then(function (data) {
        if (!data || !Array.isArray(data.items)) return;
        shareState.shareEnabled = Boolean(data.shareEnabled);
        shareState.shareUrl = data.shareUrl || "";
        write(mergeItems(read(), fromServerItems(data.items)));
        updateCounts();
        updateToggleButtons();
        renderDrawer();
        synced = true;
        return persistToServer();
      })
      .catch(function () {});
  }

  function hintText() {
    var name = displayNameFromDom();
    var url = shareState.shareUrl || "";
    return name ? "A little hint from " + name + "… " + url : "A little hint… " + url;
  }

  function copyShareUrl() {
    var url = shareState.shareUrl;
    if (!url) return Promise.resolve(false);
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(url).then(function () {
        return true;
      }).catch(function () {
        return false;
      });
    }
    return Promise.resolve(false);
  }

  function dropHint() {
    if (!isLoggedIn()) return Promise.resolve();
    return fetch(proxyBase() + "/wishlist.json", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      cache: "no-store",
      body: JSON.stringify({
        action: "share",
        displayName: displayNameFromDom(),
      }),
    })
      .then(function (res) {
        if (!res.ok) throw new Error("share failed");
        return res.json();
      })
      .then(function (data) {
        shareState.shareEnabled = true;
        shareState.shareUrl = data.shareUrl || "";
        updateFooter();
        syncShareUi(document);
        var url = shareState.shareUrl;
        if (!url) return;
        if (navigator.share) {
          return navigator
            .share({ title: "Wish List", text: hintText(), url: url })
            .catch(function () {
              return copyShareUrl();
            });
        }
        return copyShareUrl();
      })
      .catch(function () {});
  }

  function stopSharing() {
    if (!isLoggedIn()) return Promise.resolve();
    return fetch(proxyBase() + "/wishlist.json", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      cache: "no-store",
      body: JSON.stringify({ action: "unshare" }),
    })
      .then(function (res) {
        if (!res.ok) return null;
        return res.json();
      })
      .then(function (data) {
        shareState.shareEnabled = false;
        if (data && data.shareUrl) shareState.shareUrl = data.shareUrl;
        updateFooter();
        syncShareUi(document);
      })
      .catch(function () {});
  }

  document.addEventListener("click", function (e) {
    var toggle = e.target.closest("[data-favourite-toggle]");
    if (toggle) {
      e.preventDefault();
      toggleProduct(toggle);
      return;
    }

    if (e.target.closest("[data-favourites-open]")) {
      e.preventDefault();
      openDrawer();
      return;
    }

    if (e.target.closest("[data-favourites-close]")) {
      e.preventDefault();
      closeDrawer();
      return;
    }

    if (e.target.closest("[data-wishlist-drop-hint]")) {
      e.preventDefault();
      dropHint();
      return;
    }

    if (e.target.closest("[data-wishlist-stop]")) {
      e.preventDefault();
      stopSharing();
      return;
    }

    var copyBtn = e.target.closest("[data-wishlist-copy]");
    if (copyBtn) {
      e.preventDefault();
      copyShareUrl().then(function (ok) {
        if (!ok) return;
        var label = copyBtn.getAttribute("data-copied-label") || "Copied";
        var original = copyBtn.textContent;
        copyBtn.textContent = label;
        setTimeout(function () {
          copyBtn.textContent = original;
        }, 1600);
      });
    }
  });

  function migrateStoredImages() {
    try {
      var raw = JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
      if (!Array.isArray(raw) || !raw.length) return;
      var changed = false;
      var next = raw.map(function (item) {
        if (!item || typeof item !== "object") return item;
        var image = upgradeImageUrl(item.image || "");
        if (image !== (item.image || "")) changed = true;
        return Object.assign({}, item, { image: image });
      });
      if (changed) write(next);
    } catch (e) {}
  }

  document.addEventListener("DOMContentLoaded", function () {
    migrateStoredImages();
    updateCounts();
    updateToggleButtons();
    updateFooter();
    if (isLoggedIn() && !isRecipientView()) pullAndMerge();
  });

  window.WearableFavourites = {
    read: read,
    write: write,
    toggle: toggle,
    isFavourite: isFavourite,
    openDrawer: openDrawer,
    renderDrawer: renderDrawer,
    updateToggleButtons: updateToggleButtons,
    updateCounts: updateCounts,
    removeById: removeById,
    shareState: shareState,
    dropHint: dropHint,
    stopSharing: stopSharing,
    pullAndMerge: pullAndMerge,
    shareSlugFromLocation: shareSlugFromLocation,
    fromServerItems: fromServerItems,
    isLoggedIn: isLoggedIn,
    isRecipientView: isRecipientView,
    proxyBase: proxyBase,
    upgradeImageUrl: upgradeImageUrl,
    synced: function () {
      return synced;
    },
  };
})();
